import React, {PropTypes} from 'react';
import PaymentComponent from '../../payment/payment';
import validate from '../../util/validate';
import {Link, browserHistory} from 'react-router';
import postAShipmentActions from '../post_a_shipment_actions';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {routerActions} from 'react-router-redux';
import authActions from '../../auth/auth_actions';
import CONSTANTS from '../../common_constants';

class Payment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shipmentId:""
    }
  }
  goBack = () =>{
    if(this.state.shipmentId)
      browserHistory.push('/post-a-shipment/confirm-details?shipmentId='+ this.state.shipmentId);
    else
      browserHistory.push('/post-a-shipment/confirm-details');
  }
  componentDidMount(){
    if(validate.isEmpty(this.props.postAShipment))
        browserHistory.push('/post-a-shipment');
    const shipmentId = this.props.location.query.shipmentId;
    this.setState({
      shipmentId
    })
    this.getDiscountDetails()
  }
  getDiscountDetails = () =>{
    let params={} ;
    const self = this;
    if(this.props.postAShipment)
    {
      params.shipmentCost = this.props.postAShipment.shipmentCost ? this.props.postAShipment.shipmentCost : 0;
      params.userType = 1 //post a shipment
      this.props.postAShipmentActions.getDefaultDiscount(params).then((data) => {
        self.formatShipmentDiscountDetails(data);
      }, (errorRes) => {
          if(errorRes.error === CONSTANTS.sessionInvalid){
            this.setState({ajaxInProgress: false})
            this.props.authActions.sessionValid(false);
            cookies.delete('_sd');
            return ;
          }
      })
    }
  }
  formatShipmentDiscountDetails = (discount) =>{
      let postAShipment = Object.assign({}, this.props.postAShipment)
      if(!discount.isOfferExists)
      {
          postAShipment.discount = false
      }else{
        postAShipment.discount = true;
        if(discount.isPromoCode)
        {
          postAShipment.promoCode = discount.promoCode;
          postAShipment.offerValue = discount.offerValue;
        }else{
          postAShipment.promoCode = "Referral";
          postAShipment.percentageDiscount = discount.percentageDiscount;
        }
      }
      this.setState({
        postAShipment
      })
  }
  render() {
    return (
      <div className = "post-a-shipment-payment-main-wrap">
        <PaymentComponent paymentFor = {1}shipmentId ={this.state.shipmentId} shipmentWidgetDetails = {this.state.postAShipment}/>
      </div>
    )
  }
}

Payment = connect((state) => {
  return {
    postAShipment : state.app.postAShipment
  }
}, (dispatch) => {
  return {
    routerActions: bindActionCreators(routerActions, dispatch),
    postAShipmentActions :bindActionCreators(postAShipmentActions, dispatch),
    authActions : bindActionCreators(authActions, dispatch)
  }
})(Payment);

export default Payment;



// WEBPACK FOOTER //
// app/post_a_shipment/payment/post_a_shipment_payment.jsx